import { useMemo } from 'react';
import { RangeRenderer } from './RangeRenderer';
import { useReaderConfiguration } from '../../ReaderConfiguration/ReaderConfigurationContext';
import { Box, Skeleton, Typography } from '@mui/material';
import '@fontsource/literata';
import { useSessionContext } from '../../../components/SessionContext';
import { useReaderContext } from './ReaderContext';
import '../typography.css';

export default function ContentRenderer() {
  const { state } = useReaderContext();
  const { annotations, htmlRange } = useSessionContext();
  const { config } = useReaderConfiguration();

  const annotationsInRange = useMemo(() => {
    if (!htmlRange) {
      return [];
    }

    return annotations.filter((annotation) => {
      return (
        (annotation.position.start.blockId >= htmlRange.range.startBlockIndex &&
          annotation.position.start.blockId <= htmlRange.range.endBlockIndex) ||
        (annotation.position.end.blockId >= htmlRange.range.startBlockIndex &&
          annotation.position.end.blockId <= htmlRange.range.endBlockIndex)
      );
    });
  }, [annotations, htmlRange]);

  return (
    <Box sx={{ fontFamily: ['Literata', 'serif'].join(',') }}>
      {(htmlRange === null || state === 'loading') && (
        <Box>
          <Typography variant='h1'>
            <Skeleton />
          </Typography>
          <Typography variant='h2'>
            <Skeleton />
          </Typography>
          <Typography variant='body1'>
            <Skeleton />
          </Typography>
          <Typography variant='body1'>
            <Skeleton />
          </Typography>
          <Typography variant='body1'>
            <Skeleton />
          </Typography>
          <Typography variant='body1'>
            <Skeleton />
          </Typography>
          <Typography variant='body1'>
            <Skeleton />
          </Typography>
        </Box>
      )}
      {htmlRange !== null && state === 'ready' && (
        <RangeRenderer
          htmlString={htmlRange.htmlString}
          annotations={annotationsInRange}
          renderOptions={{
            renderHighlights: config.showHighlights,
          }}
        />
      )}
    </Box>
  );
}
